// Boîte de dialogue de la vitrine, en remplacement des alert() natifs.
//
// SweetAlert2 n'est chargé que dans l'admin : l'embarquer ici alourdirait le
// bundle de la boutique pour un seul message. Ce composant reprend les codes
// du toast déjà en place (mêmes couleurs, même typographie).
//
// Accessibilité : le dialogue prend le focus, le rend au déclencheur en
// partant, se ferme par Échap ou par un clic sur le fond, et piège la
// tabulation pour qu'on ne navigue pas derrière lui.
let openDialog = null

function close() {
  if (!openDialog) return

  const { element, previouslyFocused, onKeydown } = openDialog
  openDialog = null

  document.removeEventListener("keydown", onKeydown)
  element.classList.remove("is-visible")
  previouslyFocused?.focus?.()

  setTimeout(() => element.remove(), 200)
}

export function showModal({ title, message, primaryLabel, primaryHref, dismissLabel = "Fermer", icon = "cart" }) {
  close()

  const element = document.createElement("div")
  element.className = "vitrine-modal-backdrop"
  element.innerHTML = `
    <div class="vitrine-modal" role="dialog" aria-modal="true" aria-labelledby="vitrine-modal-title">
      <span class="vitrine-modal-icon" aria-hidden="true">${ICONS[icon] || ICONS.cart}</span>
      <h2 class="vitrine-modal-title" id="vitrine-modal-title">${title}</h2>
      <p class="vitrine-modal-message">${message}</p>
      <div class="vitrine-modal-actions">
        ${primaryHref ? `<a class="vitrine-modal-btn vitrine-modal-btn--primary" href="${primaryHref}">${primaryLabel}</a>` : ""}
        <button type="button" class="vitrine-modal-btn vitrine-modal-btn--ghost" data-modal-dismiss>${dismissLabel}</button>
      </div>
    </div>
  `

  const onKeydown = (event) => {
    if (event.key === "Escape") return close()
    if (event.key !== "Tab") return

    const focusable = element.querySelectorAll("a[href], button")
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  element.addEventListener("click", (event) => {
    // Un clic sur le fond ferme ; un clic dans le panneau ne doit pas.
    if (event.target === element || event.target.hasAttribute("data-modal-dismiss")) close()
  })

  document.body.appendChild(element)
  openDialog = { element, previouslyFocused: document.activeElement, onKeydown }
  document.addEventListener("keydown", onKeydown)

  requestAnimationFrame(() => {
    element.classList.add("is-visible")
    element.querySelector(".vitrine-modal-btn")?.focus()
  })

  return { close }
}

const ICONS = {
  cart: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"
              stroke-linecap="round" stroke-linejoin="round">
    <path d="M6 7h13l-1.3 8.2a2 2 0 0 1-2 1.7H9.1a2 2 0 0 1-2-1.7L5.6 5.4A1 1 0 0 0 4.6 4.6H3"/>
    <circle cx="10" cy="20" r="1.1"/><circle cx="17" cy="20" r="1.1"/>
  </svg>`
}
